import { useState, useCallback } from "react";
import { useUIStore } from "../store/uiStore";

/**
 * Shared POI selection wiring for map panes (day focus view, trip map view)
 * and the sidebar: selection lives in uiStore.selectedMapPoiId, independent
 * of the proximity-sort target (uiStore.targetPoiId), so selecting/flying to
 * a POI never changes sort order. Selecting a POI also bumps flyToTrigger so
 * MapView flies to it.
 */
export function useMapPoiSelection() {
  const selectedMapPoiId = useUIStore((s) => s.selectedMapPoiId);
  const setSelectedMapPoiId = useUIStore((s) => s.setSelectedMapPoiId);
  const [flyToTrigger, setFlyToTrigger] = useState(0);

  const handleSelectPoi = useCallback(
    (poiId: string | null) => {
      setSelectedMapPoiId(poiId);
      if (poiId) {
        setFlyToTrigger((t) => t + 1);
      }
    },
    [setSelectedMapPoiId],
  );

  return { selectedMapPoiId, flyToTrigger, handleSelectPoi };
}
